package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.ccabserver.transcriptreview.states.EngineWordStateGenerator
import com.neurobs.react.StyleUtil
import com.neurobs.react.semanticui.{UiButtonFactory, UiIconFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useState
import slinky.web.html._

import scala.scalajs.js

@react
object EngineWord {

  case class Props()

  val component = FunctionalComponent[Props] { props =>

    val engineWordState = EngineWordStateGenerator.accessState

    def displayConfidence = engineWordState.displayConfidence

    def handleMouseEnter() = engineWordState.handleMouseEnter()
    def handleMouseOut() = engineWordState.handleMouseOut()
    def handleClick() = engineWordState.handleClick()

    div(
      className := "reviewable-word",
      style := engineWordState.generateStyle,
    //  onMouseOver := {() => handleMouseEnter()},
    //  onMouseOut := {() => handleMouseOut()},
      onClick := {() => handleClick()}
    )(
      engineWordState.word.word,
      if (displayConfidence) ConfidenceDisplay(engineWordState.word.confidence)
      else null
    )

  }
}

@react
object ConfidenceDisplay {
  case class Props(confidence: Double)
  val component = FunctionalComponent[Props] { props =>

    val formatConf = {
      if (props.confidence == 1) "1.0"
      else {
        val postDecimal = props.confidence.toString.dropWhile(_ != '.').drop(1).take(3).padTo(2, '0')
        s"0.$postDecimal"
      }
    }

    def hiddenStyle = Seq[(String, js.Any)](
      ("position", "absolute"), ("top", "-20px"), ("height", "20px"), ("right", "-1px"), ("padding", "5px")
    )

    div(
      className := "ui inverted mini button",
      style := StyleUtil.makeStyle(hiddenStyle:_*),
      onMouseOver := {() => {}},
      onMouseOut := {() => {}}
    )(formatConf)

  }
}